import { render, staticRenderFns } from "./ToBeResolved.vue?vue&type=template&id=08c7b5d2&"
import script from "./ToBeResolved.vue?vue&type=script&lang=js&"
export * from "./ToBeResolved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports